'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarPrice = renderWithRef('PriceBarPrice', null, (c, o)=>{
    let { children: t } = c;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: new Set([
            'swan-price-bar-price'
        ]),
        props: c,
        children: t
    });
});

export { PriceBarPrice };
